module.exports = __webpack_public_path__ + "images/FUSA_icons/048-online-shop-2.c53229b1905b0a61a04bd827e6a4b2ee.svg";